export const types = {
    BLOCK_USER: "BLOCK_USER",
    DELETE_USER_REPORTS: "DELETE_USER_REPORTS",
}
